import { render, staticRenderFns } from "./PrepareForVerificationDesktopSvg.vue?vue&type=template&id=321c3552&"
import script from "./PrepareForVerificationDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./PrepareForVerificationDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports